import { render, staticRenderFns } from "./CommunicationLogSidebar.vue?vue&type=template&id=5d21317c&scoped=true&"
import script from "./CommunicationLogSidebar.vue?vue&type=script&lang=js&"
export * from "./CommunicationLogSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationLogSidebar.vue?vue&type=style&index=0&id=5d21317c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d21317c",
  null
  
)

export default component.exports